export const SCORE_COLORS = {
  green: "#9AE600",
  yellow: "#FFB86A",
  red: "#FF6467",
} as const;

export type ScoreColorName = keyof typeof SCORE_COLORS;

export const getScoreColorName = (
  matchPercentage: string | number | null | undefined,
): ScoreColorName | null => {
  if (matchPercentage === null || matchPercentage === undefined) return null;
  const matchPercent = Number(matchPercentage) || 0;

  if (matchPercent >= 80) return "green";
  if (matchPercent >= 65 && matchPercent <= 79.9) return "yellow";
  return "red";
};

export const getScoreIndicator = (
  matchPercentage: string | number | null | undefined,
): string => {
  const colorName = getScoreColorName(matchPercentage);
  return colorName ? SCORE_COLORS[colorName] : "";
};
